// Hand-maintained descriptive text for each conference year, shown on the
// homepage and used by the sidebar. This is NOT required for a year to show
// up in the site -- useDiscoveredYears() finds years purely from the
// presence of the `${year}.csv` / `${year}-authors.csv` pair. A year with no
// entry here still appears, just without the extra description block.
//
// `hasSessions` controls whether a "By Session" link is shown; only turn it
// on for years whose CSV actually has a populated `conference_session` column.
export const conferenceMeta = {
  2025: {
    bodyLines: [
      'October 17-19, 2025',
      'Rome, Italy',
      'Editors: Calogero Oddo e Gabriele Costante',
      'ISBN: 9788894580570',
    ],
    website: 'https://i-rim.it/it/conferenza-i-rim-3d-2025/',
    hasSessions: false,
  },
  2024: {
    bodyLines: [
      'October 25-27, 2024',
      'Rome, Italy',
      'Editors: Loredana Zollo, Giulio Rosati e Luigi Palopoli',
      'ISBN: 9788894580556',
    ],
    website: 'https://i-rim.it/it/conferenza-i-rim-3d-2024/',
    hasSessions: false,
  },
  2023: {
    bodyLines: [
      'October 20-22, 2023',
      'Rome, Italy',
      'Editors: Gianluca Antonelli, Giuseppe Carbone, Arianna Menciassi, Silvia Rossi',
      'ISBN: 9788894580549',
    ],
    website: 'https://i-rim.it/it/conferenza-i-rim-2023/',
    hasSessions: false,
  },
  2022: {
    bodyLines: [
      'VOL. 1: Editors: Antonio Frisoli, Federica Pascucci',
      'October 7-9, 2022',
      'Rome, Italy',
      '',
      'VOL.2: Editors: Paolo Rocco, Lorenzo Molinari Tosatti',
      'October 13-14, 2022',
      'Milan, Italy',
      'ISBN: 978-88-945805-3-2',
    ],
    website: 'https://i-rim.it/en/program/',
    hasSessions: false,
  },
  2021: {
    bodyLines: [
      'October 8-10, 2021',
      'Rome, Italy (Virtual)',
      'Editors: Christian Cipriani, Maria Pia Fanti, Monica Malvezzi, Angelika Peer',
      'ISBN: 9788894580525',
    ],
    website: 'https://i-rim.it/en/program/',
    hasSessions: false,
  },
  2020: {
    bodyLines: [
      'December 10-12, 2020',
      'Rome, Italy (Virtual)',
      'Editors: Benedetto Allotta, Maria Chiara Carrozza, Emanuele Menegatti and Giuseppe Oriolo',
      'ISBN: 9788894580518',
    ],
    website: 'https://i-rim.it/en/program/',
    hasSessions: true,
  },
  2019: {
    bodyLines: [
      'October 18-20, 2019',
      'Rome, Italy',
      'Editors: Barbara Caputo, Cecilia Laschi and Domenico Prattichizzo',
      'ISBN: 9788894580501',
    ],
    website: 'https://i-rim.it/en/pitches-and-posters-2/#posters',
    hasSessions: true,
  },
};
